
import errorHandler from './errorHandler'
import api from '../../api/async'

export const replyDirectMessageAsync = async (payload, formData) => {
        return await api.postFormData("/facebook/directmessages/" + payload.query.conversationId +".reply", formData);   
    }



// WEBPACK FOOTER //
// ./src/libs/facebook/replyDirectMessageAsync.js